import { useAuthStore } from "@/stores/authStore"
import { api } from "./config"

export const fetchShops = () => {
    const accessToken = useAuthStore.getState().auth.accessToken
    const shops = (): Promise<any> =>
        api.get('shops', {
            params: { list_all: true },
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        }).then((response: any) => response.data.data)

    return shops
}

export const fetchShop = async (shopId: string) => {
    const accessToken = useAuthStore.getState().auth.accessToken

    return api.get(`shops/${shopId}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    }).then((response: any) => response.data.data)
}

export const fetchShopMenu = async (shopId: string) => {
    const accessToken = useAuthStore.getState().auth.accessToken

    return api.get(`shops/${shopId}/menu`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    }).then((response: any) => response.data.data)
}

/** API / wire shape — snake_case */
export type ShopSlugAvailabilityWire = {
    available: boolean
    slug: string
    reason?: 'invalid' | 'taken'
}

export const checkShopSlugAvailability = async (
    shopId: string,
    slug: string,
    signal?: AbortSignal
): Promise<ShopSlugAvailabilityWire> => {
    const accessToken = useAuthStore.getState().auth.accessToken

    return api
        .get('shops/slug-availability', {
            params: { shop_id: shopId, slug },
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            signal,
        })
        .then((response: { data: { data: ShopSlugAvailabilityWire } }) => response.data.data)
}

export type UpdateShopPayload = {
    name?: Record<string, string>
    description?: Record<string, string>
    settings?: Record<string, unknown>
    slug?: string
    logo_file?: Record<string, unknown>
}

export const updateShop = async (shopId: string, data: UpdateShopPayload) => {
    const accessToken = useAuthStore.getState().auth.accessToken

    return api.put(`shops/${shopId}`, data, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    }).then((response: any) => response.data.data)
}

export const createShop = async (data: any, optioanlToken?: string) => {
    const accessToken = optioanlToken || useAuthStore.getState().auth.accessToken

    return api.post('shops', data, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    }).then((response: any) => response.data.data)
}